enum OperacaoMatematica {
    Somar = 0,
    Subtrair = 1,
    Multiplicar = 2,
    Dividir = 3
}

export default OperacaoMatematica;